import React from "react";
import CALL_ICON from './../../../../../assets/images/call_icon.svg';
import {useDispatch} from "react-redux";
import {openOrderSafeCallModal, openPrescriptionModal} from "../../../../../redux/actions/modals";
import PrescriptionZoomComponent from "./../../modals/PrescriptionZoomComponent";
import PharmacyOrderActions from "./PharmacyOrderActions";
const PharmacyOrderItemMobile = (props) => {
    const dispatch = useDispatch();
    const {
        id,
        jalali_created_at,
        customer_contact_name,
        customer_contact_phone,
        customer_description,
        force_return,
        use_insurance,
        prescriptions,
        prices,
        partial_offer_id,
        actual_price
    } = props;
    const getPrescriptionReason = () => {
        if (!force_return){
            return "-";
        }
        if (use_insurance){
            return "نسخه شامل بیمه است.";
        }else{
            return "نسخه شامل داروی خاص است.";
        }
    }

    const renderPartialItemsDescriptions = (item) => {
        if(partial_offer_id !== null && item.tag === "PRESCRIPTION") {
            return(
                <>
                <div className="partial-order-existence-list-mobile">
                    <p>لیست اقلام ناموجود:</p>
                    <div className="list-items">
                    {item.partialOfferDescription.split('\n').map((line,index) => {
                            return <span>{line}<br/></span>
                        })}
                    </div>
                </div> 
                </>
            )
        }
    }

    return (
        <div className="pharmacy-order-item-mobile bg-white shadow-sm rounded">
            <div className='top-holder'>
                <div className="date-and-time">
                    {jalali_created_at}
                </div>
                <div className="order-id">
                    #{id}
                </div>
            </div>
            <div className='customer-data-holder'>
                <div className='customer-name'>
                    {customer_contact_name}
                </div>
                <div className='customer-contact-data'>
                    <div className='customer-phone'>
                        {customer_contact_phone}
                    </div>
                    <div className="call-icon-holder" onClick={() => dispatch(openOrderSafeCallModal(props))}>
                        <img src={CALL_ICON} width={15} alt='call-icon'/>
                    </div>
                </div>
            </div>
            <div className='order-details'>
                <div className='general-data'>
                    <div className='general-data-item'>
                        <div className='key'>
                            نیاز به ارسال نسخه
                        </div>
                        <div className='value'>
                            {force_return ? 'دارد' : "ندارد"}
                        </div>
                    </div>

                    <div className='general-data-item'>
                        <div className='key'>
                            دلیل ارسال نسخه
                        </div>
                        <div className='value'>
                            {getPrescriptionReason()}
                        </div>
                    </div>
                </div>
                <div className='general-data' style={{marginTop:7,marginBottom:7}}>
                    <div className='general-data-item'>
                        <div className='key' style={{textAlign:'right'}}>
                            توضیحات
                        </div>
                        <div className='value'  style={{fontWeight:'100'}}>
                            {customer_description ?? '-'}
                        </div>
                    </div>
                </div>
                {actual_price !== '0' && actual_price !== 0 && (
                <div className="price-mobile-pharmacy">
                    مبلغ سفارش: {actual_price} تومان
                </div>
                )}
                <div className='order-items-list'>
                    {

                        prescriptions.map((item,index) => {
                            let price = prices.find(price_item => price_item.id === item.order_item_id)
                            return (
                                <>
                                    <div className='order-item' key={index}>
                                        <div className='prescription-img' onClick={() => {
                                            dispatch(openPrescriptionModal(item.url))
                                        }}>
                                            <img src={item.url} alt="prescription-img" width={80} height={80}/>
                                        </div>
                                        <div className='prescription-data'>
                                            <div className='title'>
                                                برای {price.count} نفر
                                            </div>
                                            <div className='prescription-description'>
                                                <div className='key'>
                                                    توضیحات :
                                                </div>
                                                <div className='value'>
                                                    {item.description}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        {renderPartialItemsDescriptions(item) }
                                    </div>

                                </>
                            )
                        })
                    }
                </div>
                <PharmacyOrderActions order={props} />
            </div>
            <PrescriptionZoomComponent />
        </div>
    )
};

export default PharmacyOrderItemMobile;